import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import API_BASE_URL from "../api/api";

const TeacherCV = () => {
  const { id } = useParams();

  const [teacher, setTeacher] = useState(null);
  const [cvData, setCvData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCV = async () => {
      try {
        const response = await fetch(
  `${API_BASE_URL}/teacher/${encodeURIComponent(id)}/cv`,
  {
    headers: {
      Accept: "application/json",
    },
  }
);

const result = await response.json();

if (!response.ok || !result.status) {
  throw new Error(result.message || "CV data not found");
}

setTeacher(result.teacher);
setCvData(result.data || []);

        setTeacher(result.teacher);
        setCvData(result.data || []);
      } catch (err) {
        console.error("CV API Error:", err.response?.data || err.message);

        setError(
          err.response?.data?.message ||
          err.message ||
          "Unable to fetch CV data"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchCV();
  }, [id]);

  if (loading) {
    return <div className="p-8 text-center">Loading CV...</div>;
  }

  if (error) {
    return (
      <div className="p-8 text-center text-red-600">
        {error}
      </div>
    );
  }

  const cv = cvData[0];

  if (!teacher || !cv) {
    return (
      <div className="p-8 text-center text-red-600">
        CV data not found.
      </div>
    );
  }

  const academicProfiles = [
    ["Google Scholar ID", cv.google_scholar_id],
    ["Vidwan ID", cv.vidwan_id],
    ["IRINS Profile", cv.irins_profile_url],
    ["ORCID ID", cv.orcid_id],
    ["Scopus Author ID", cv.scopus_author_id],
    ["ResearchGate Profile", cv.researchgate_profile_url],
    ["Academia.edu Profile", cv.academia_edu_profile_url],
    ["Other Academic / Research Profiles", cv.other_academic_research_profiles],
  ];

  const renderValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return <span className="text-gray-400">Not provided</span>;
    }

    if (typeof value === "string" && /^https?:\/\/\S+$/i.test(value)) {
      return (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 hover:underline break-all"
        >
          View Profile
        </a>
      );
    }

    return String(value);
  };

  const DetailRow = ({ label, value }) => (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 px-4 py-3 border-b border-gray-200">
      <div className="font-semibold text-gray-700">{label}</div>
      <div className="sm:col-span-2 text-gray-800 break-words">
        {renderValue(value)}
      </div>
    </div>
  );

  
return (
  <div className="min-h-screen bg-slate-100 px-3 py-8 sm:px-6 lg:px-8 print:bg-white print:p-0">
    <div
      id="teacher-cv"
      className="mx-auto max-w-5xl overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl print:max-w-none print:rounded-none print:border-0 print:shadow-none"
    >
      {/* University-style header */}
      <header className="relative overflow-hidden bg-[#123566] px-5 py-9 text-white sm:px-10">
        <div className="absolute -right-12 -top-16 h-56 w-56 rounded-full border-[24px] border-white/5" />
        <div className="absolute -bottom-20 -left-10 h-48 w-48 rounded-full border-[20px] border-white/5" />

        <div className="relative z-10 flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:text-left">
          <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border-2 border-white/40 bg-white/10">
            <i className="fa-solid fa-graduation-cap text-4xl text-white" />
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">
              Faculty Profile
            </p>

            <h1 className="mt-2 text-2xl font-bold tracking-wide sm:text-3xl">
              CURRICULUM VITAE
            </h1>

            <p className="mt-2 text-sm text-blue-100">
              Academic, Teaching & Research Profile
            </p>
          </div>

          <div className="hidden h-16 w-px bg-white/20 sm:block" />

          <div className="text-sm leading-6 text-blue-100 sm:max-w-48 sm:text-right">
            <p className="font-semibold text-white">
              {cv.campus || "Kumaun University"}
            </p>
            <p>Faculty Information</p>
          </div>
        </div>
      </header>

     

      <main className="space-y-8 px-5 py-7 sm:px-10 sm:py-9">
        {/* Personal and contact details */}
        <section>
          <div className="mb-4 flex items-center gap-3 border-b-2 border-blue-100 pb-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-[#2456a6]">
              <i className="fa-regular fa-address-card text-lg" />
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900">
                Personal & Contact Details
              </h3>
              <p className="text-xs text-slate-500">
                Official contact and institutional information
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {[
              ["Full Name", cv.full_name],
              ["Designation", cv.designation],
              ["Faculty", cv.faculty],
              ["Department", cv.department],
              ["Campus", cv.campus],
              ["Email Address", cv.email_address],
              [
                "Official Institutional Email",
                cv.official_institutional_email_id,
              ],
              ["Contact Number", cv.contact_number],
            ].map(([label, value]) => (
              <div
                key={label}
                className="min-w-0 rounded-lg border border-slate-200 bg-white px-4 py-3"
              >
                <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
                  {label}
                </p>
                <p className="break-words text-sm font-medium text-slate-800">
                  {value || "Not provided"}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Academic and research profiles */}
        <section>
          <div className="mb-4 flex items-center gap-3 border-b-2 border-blue-100 pb-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-[#2456a6]">
              <i className="fa-solid fa-book-open text-lg" />
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900">
                Academic & Research Profiles
              </h3>
              <p className="text-xs text-slate-500">
                Research identifiers and academic profile links
              </p>
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-slate-200">
            {academicProfiles
              .filter(([, value]) => value)
              .map(([label, value], index) => {
                const isUrl =
                  typeof value === "string" &&
                  /^https?:\/\/\S+$/i.test(value.trim());

                return (
                  <div
                    key={label}
                    className={`grid grid-cols-1 gap-2 px-4 py-4 sm:grid-cols-[220px_minmax(0,1fr)] sm:gap-5 ${
                      index % 2 === 0 ? "bg-slate-50" : "bg-white"
                    } border-b border-slate-100 last:border-b-0`}
                  >
                    <p className="text-sm font-semibold text-slate-600">
                      {label}
                    </p>

                    <div className="min-w-0 break-words text-sm text-slate-800">
                      {isUrl ? (
                        <a
                          href={value.trim()}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-medium text-blue-700 underline decoration-blue-200 underline-offset-4 hover:text-blue-900 print:text-black"
                        >
                          Open Profile
                          <i className="fa-solid fa-arrow-up-right-from-square ml-2 text-xs print:hidden" />
                        </a>
                      ) : (
                        value
                      )}
                    </div>
                  </div>
                );
              })}

            {academicProfiles.filter(([, value]) => value).length === 0 && (
              <p className="px-4 py-6 text-sm text-slate-500">
                No academic or research profiles have been provided.
              </p>
            )}
          </div>
        </section>

        
      </main>

      {/* Action buttons */}
      <div className="flex flex-wrap justify-center gap-3 border-t border-slate-200 bg-slate-50 p-5 print:hidden">
        <button
          type="button"
          onClick={() => window.print()}
          className="inline-flex items-center rounded-lg bg-[#123566] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-900"
        >
          <i className="fa-solid fa-print mr-2" />
          Print CV
        </button>

        
      </div>
    </div>

    <style>{`
      @page {
        size: A4;
        margin: 12mm;
      }

      @media print {
        html,
        body {
          background: #fff !important;
          margin: 0 !important;
          padding: 0 !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        body * {
          visibility: hidden;
        }

        #teacher-cv,
        #teacher-cv * {
          visibility: visible;
        }

        #teacher-cv {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;

  /* A4 width minus 8mm margins on both sides */
  width: 194mm !important;
  max-width: 194mm !important;
  min-height: 0 !important;
  height: auto !important;

  margin: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;

  box-sizing: border-box !important;
}

        #teacher-cv header,
        #teacher-cv section,
        #teacher-cv footer {
          break-inside: avoid;
        }

        #teacher-cv a {
          text-decoration: none;
        }

        #teacher-cv main {
          padding: 20px 0;
        }

        #teacher-cv .print\\:hidden {
          display: none !important;
        }
      }
    `}</style>
  </div>
);

};

export default TeacherCV;